import React from 'react';
import styled from 'styled-components';

import { useModals, ModalNames } from 'src/components/modals';
import { tracker } from 'src/utils/analytics';
import { AppleLogin, GoogleLogin } from 'src/components/social-login';
import useUI from 'src/hooks/use-ui';
import { KioskLoggedOutEmptyCart } from './kiosk-logged-out-empty-cart';

type TrackEventProps = {
  type: 'email' | 'sso';
};

export const LoggedOut = (): JSX.Element => {
  const { openModal } = useModals();
  const { isKiosk } = useUI();

  const handleLogin = (): void => {
    void openModal(ModalNames.login);
    trackEvent({ type: 'email' });
  };

  const trackEvent = ({ type }: TrackEventProps): void => {
    tracker.gaGTMClickEvent({
      eventCategory: 'cart',
      eventAction: 'signed in',
      eventLabel: `${type}: {pageType}`,
    });
  };

  if (isKiosk) {
    return <KioskLoggedOutEmptyCart />;
  }

  return (
    <Actions>
      <Buttons>
        <ButtonWrapper>
          <GoogleLogin redirectUrl={window.location.href} onSubmit={() => trackEvent({ type: 'sso' })} />
        </ButtonWrapper>

        <ButtonWrapper>
          <AppleLogin redirectUrl={window.location.href} onSubmit={() => trackEvent({ type: 'sso' })} />
        </ButtonWrapper>
      </Buttons>

      <InlineLink onClick={handleLogin} data-testid='log-in-or-sign-up-with-email-button'>
        Log in or sign up with email
      </InlineLink>
    </Actions>
  );
};

const Actions = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 24px;
  min-width: 318px;
  gap: 16px;
  width: 100%;
`;

const Buttons = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const ButtonWrapper = styled.div`
  flex: 1;
`;

const InlineLink = styled.button`
  appearance: none;
  background: none;
  border: none;
  color: ${({ theme }) => theme.customized.colors.buttonsLinks};
  cursor: pointer;
  font-family: inherit;
  font-size: 14px;
  font-weight: 700;
  line-height: ${24 / 14};
  padding: 0;
  text-decoration: underline;

  &:hover {
    text-decoration: none;
  }
`;
